module.exports = require("@babel/polyfill");